import { AgentKernelRequest } from "@/types/app/agent";
import { ToolUsage } from "@/types/app/prompt";

export const USER_INPUT_TOOL = {
  type: "inline" as const,
  on_agent_call: "continue" as const,
  json_schema: {
    name: "get_user_input",
    description:
      "This tool is used to get user input. Call it whenever you need to ask the user for feedback or ask a question.",
    parameters: {
      type: "object",
      properties: {
        prompt: {
          type: "string",
          description: "The prompt to ask the user.",
        },
      },
      additionalProperties: false,
      required: ["prompt"],
    },
    strict: true,
  },
  usage: ["tool_calling"] satisfies ToolUsage[],
};

export const STOP_TOOL = {
  type: "inline" as const,
  on_agent_call: "stop" as const,
  json_schema: {
    name: "exit_with_output",
    description: "This tool is used to exit. Call it when you have finished your task.",
    parameters: {
      type: "object",
      properties: {
        output: {
          type: "string",
          description: "The final output to return to the user.",
        },
      },
      additionalProperties: false,
      required: ["output"],
    },
    strict: true,
  },
  usage: ["tool_calling"] satisfies ToolUsage[],
};

export const DEFAULT_AGENT: AgentKernelRequest = {
  model: "gpt-4o",
  endpoint: "chat",
  template: [
    {
      role: "system",
      content: "You are a helpful agent.",
    },
  ],
  provider: "openai",
  tools: [USER_INPUT_TOOL, STOP_TOOL],
};
